// removed by extract-text-webpack-plugin
module.exports = {"m-orderSummaryTotals":"_1z-Kc0zazAmegY8A78gwaq","t-h4":"_1BVr6jHdmXtnmn_xZrhDJA","m-orderSummaryTotals--complete":"_2wtM6IF83kmrPY7FMFlxjB","orderTotal":"_3CvsgqjcUSa0i6G-kIGmH-"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/OrderSummary/OrderSummaryTotalsStyle.scss
// module id = 444
// module chunks = 0